// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"66d3a189","221":"3e6e64fd","227":"d3e2e1b2","339":"a02b7a27","453":"c946f8b2","715":"f99170e0","851":"8b7aa3b8","885":"acbd35de"}[chunkId] + ".chunk.js";
};